import { useQuery, useMutation } from "react-query";
import { GET, GETPaginate, POST } from "../../Services";
import { notification } from "antd";

export const useListaPokemon = (data, firstFetch, setPage) => {
  return useQuery(
    ["ListaPokemon"],
    async () => await GETPaginate("pokemon/listarPokedex", data, setPage),
    {
      retry: 0,
      keepPreviusData: false,
      refetchOnWindowsFocus: false,
      enabled: firstFetch,
    }
  );
};

export const usePokemonDetalle = (n_pokedex) => {
  return useQuery(
    ["DetallePokemon"],
    async () =>
      await GET("pokemon/dataPokemonPokedex?numero_pokedex=", n_pokedex),
    {
      retry: 0,
      keepPreviusData: false,
      refetchOnWindowsFocus: false,
    }
  );
};

export const useEnviarCodigo = () => {
  //const api = "pokemon/capturarPokemon";
  const api = "canjearCodigo"
  return useMutation(async (data) => await POST(data, api), {
    onSuccess: (response) => (response),
    onError: (error) => {
      if (error.response && error.response.data) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Codigo erroneo" });
      }
    },
  });
};

export const useListarEntrenadores = () => {
  return useQuery(
    ["ListarEntrenadores"],
    async () => await GET("usuarios/listarImagenesEntrenadores", ""),
    {
      retry: 0,
      keepPreviusData: false,
      refetchOnWindowsFocus: false,
    }
  );
};

export const useEditarPerfil = () => {
    const api = "usuarios/editarUsuario";
    return useMutation(async (data) => await POST(data, api), {
      onSuccess: (response) => {
        const userData = {
          id: response.datos.id,
          usua_nombre: response.datos.usua_nombre,
          usua_nombre_real: response.datos.usua_nombre_real,
          usua_identificador: response.datos.usua_identificador,
          usua_ig: response.datos.usua_ig,
          usua_coin: response.datos.usua_coin,
          usua_comienzo: response.datos.usua_comienzo,
          usua_qr_url: response.datos.usua_qr_url,
          usua_correo: response.datos.usua_correo,
          usua_password: response.datos.usua_password,
          tius_id: response.datos.tius_id,
          role_id: response.datos.role_id,
          imag_id: response.datos.imag_id,
          created_at: response.datos.created_at,
          updated_at: response.datos.updated_at,
          imag_url: response.datos.imagen.imag_url,
          imag_nombre: response.datos.imagen.imag_nombre,
          tiam_id: response.datos.tiam_id
      };

      // Guardamos el nuevo objeto en localStorage
      localStorage.setItem("dataUser", JSON.stringify(userData));

      if (response.success) {
        notification["success"]({
          message: response.mensaje || "Perfil actualizado",
        });
      } else {
        notification["error"]({
          message: response.mensaje || "Error al actualizar perfil",
        });
      }

      },
      onError: (error) => {
        if (error.response && error.response.data) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({ message: "Codigo erroneo" });
        }
      },
    });
};

export const useMiEquipo = () => {
  return useQuery(
    ["MiEquipo"],
    async () =>
      await GET("pokemon/getEquipos", ""),
    {
      retry: 0,
      keepPreviusData: false,
      refetchOnWindowsFocus: false,
    }
  );
};

export const useMisCartas = () => {
  return useQuery(
    ["MisCartas"],
    async () =>
      await GET("pokemon/selectPokemonCapturados", ""),
    {
      retry: 0,
      keepPreviusData: false,
      refetchOnWindowsFocus: false,
    }
  );
};

export const useCrearEquipo = () => {
  const api = "pokemon/crearEquipo";
  return useMutation(async (data) => await POST(data, api), {
    onSuccess: (response) => {
      notification["success"]({ message: response.mensaje });
      return response;
    },
    onError: (error) => {
      if (error.response && error.response.data) {
        notification["error"]({ message: error.response.data.mensaje });
      } else {
        notification["error"]({ message: "Código erróneo" });
      }
    },
  });
};

export const useEliminarEquipo = () => {
  const api = "pokemon/eliminarEquipo";
  return useMutation(async (data) => await POST(data, api), {
    onSuccess: (response) => {notification["success"]({ message: response.mensaje })},
    onError: (error) => {
      if (error.response && error.response.data) {
        notification["error"]({ message: error.response.data.mensaje });
      } else {
        notification["error"]({ message: "Código erróneo" });
      }
    },
  });
};

export const useWonderCoins = () => {
  return useQuery(
    ["MisCoins"],
    async () =>
      await GET("usuarios/mostrarWonderCoins", ""),
    {
      retry: 0,
      keepPreviusData: false,
      refetchOnWindowsFocus: false,
    }
  );
}

export const useListarObjetos = (data) => {
  
  return useQuery(
    ["ListaObjetos",data],
    async () =>
      await GET(`objeto/objetosUsuario?search=${data?.search}`),
    {
      retry: 0,
      keepPreviusData: false,
      refetchOnWindowsFocus: false,
    }
  );
}

export const useConsumirObjetos = () => {
  const api = "objeto/consumirObjeto";
  return useMutation(async (data) => await POST(data, api), {
    onSuccess: (response) => {notification["success"]({ message: response.mensaje })},
    onError: (error) => {
      if (error.response && error.response.data) {
        notification["error"]({ message: error.response.data.mensaje });
      } else {
        notification["error"]({ message: "Error desconocido" });
      }
    },
  });
}

export const useListarLogros = () => {
  return useQuery(
    ["ListaLogros"],
    async () =>
      await GET("logros/listarLogrosUsuario", ""),
    {
      retry: 0,
      keepPreviusData: false,
      refetchOnWindowsFocus: false,
    }
  );
}

export const useListarZonasGachapon = () => {
  return useQuery(
    ["ListarZonasGachapon"],
    async () =>
      await GET("gachapon/listarZonasGachapon", ""),
    {
      retry: 0,
      keepPreviusData: false,
      refetchOnWindowsFocus: false,
    }
  );
}

export const useCanjearGachapon = (options = {}) => {
  const api = "gachapon/canjearGachapon";
  return useMutation({
    mutationFn: async (data) => await POST(data, api),
    ...options
  });
};

export const useConfirmarSeleccion = (options = {}) => {
  const api = "gachapon/confirmarSeleccion";
  return useMutation({
    mutationFn: async (data) => await POST(data, api),
    ...options
  });
};